import { createContext } from "react";

export const ConfigContext = createContext({
  flavour: "",
  base: "",
  user: "",
  phone: "",
});
